
import matchResultHeader from '../components/MatchResultHeader.vue'
import matchScores from './matchScores.vue'
import matchMoments from './matchMoments.vue'
import matchDynamic from './matchDynamic.vue'
import matchLive from './matchLive.vue'
import matchDynamicData from './matchDynamicData.vue'
import Tab from 'vux/src/components/tab/tab.vue'
import TabItem from 'vux/src/components/tab/tab-item.vue'
import Scroller from 'vux/src/components/scroller/index.vue'

import Vue from 'vue'
import configInfo from "../configInfo.js"
import wx from 'wx'
import  httpServer from "../js/common/http.js"
import  ApiSetting from "../js/common/api.js"
import {wxShareConfig} from '../js/common/utils'
export default{
name:'app',
components:{
matchResultHeader,
Tab,
TabItem,
matchScores,
matchMoments,
matchDynamic,
matchLive,
matchDynamicData,
Scroller,
},
created(){
this.matchId = this.$route.query.matchId;
if(this.$route.query.currentTab) {
this.currentTab = this.$route.query.currentTab
}
if(this.$route.query.liveUrl) {
this.liveUrl = this.$route.query.liveUrl
}
},
data(){
return{
eventHub: new Vue(),
tabNames:['赛况','精彩瞬间', '动态数据', '看直播'],
currentTab:'matchScoresTab',
tabShow:true,
homeTeamScore:null,
visitTeamScore:null,
homeTeamPKScore:null,
visitTeamPKScore:null,
beforeStart:require('../assets/img/matchInfo/before-start.svg'),
matchId:'',
info:'request',
pullupConfig: {
content: '',
pullUpHeight: 60,
height: 100,
autoRefresh: true,
downContent: '',
upContent: '',
loadingContent: '',
clsPrefix: 'xs-plugin-pullup-'
},
homeTeamName:'',
visitTeamName:'',
leagueName:'',
liveUrl: '',
liveStatus: '',
isEnd: ''
}
},
mounted(){

this.hagkHttp(this.hagkApi.getMatchInfoById(this.matchId), {})
.then((res) => {
console.log('================res=================')
console.log(res)
this.liveUrl = res.liveUrl;
this.liveStatus = res.liveStatus
this.isEnd = res.isEnd;
this.homeTeamName = res.homeTeamName;
this.visitTeamName = res.vistingTeamName;
this.leagueName = res.leagueName;
if(res.result && res.result != null){

if(res.result.goalFor != null){
this.homeTeamScore = 0;
this.homeTeamScore += res.result.goalFor;
}
if(res.result.homeExScore != null){
this.homeTeamScore = this.homeTeamScore == null ? 0 : this.homeTeamScore;
this.homeTeamScore += res.result.homeExScore;
}
if(res.result.homePkScore != null){
this.homePkScore = 0;
this.homeTeamPKScore += res.result.homePkScore;
}
if(res.result.goalAgainst != null){
this.visitTeamScore = 0;
this.visitTeamScore += res.result.goalAgainst;
}
if(res.result.visitorExScore != null){
this.visitTeamScore = this.visitTeamScore == null ? 0 : this.visitTeamScore;
this.visitTeamScore += res.result.visitorExScore;
}
if(res.result.visitorPkScore != null){
this.visitorPkScore = 0;
this.visitTeamPKScore += res.result.visitorPkScore;
}


if(this.homeTeamScore == null && this.visitTeamScore == null){
this.tabShow = false;
} else{
this.tabShow = true;
}
} else{
this.tabShow = false;
}
if (this.tabShow) {
document.title = "比赛结果";
var fullPath = window.location.href;
var shareImg = window.location.origin + configInfo.routerBase + "static/logo.png";
var title = this.leagueName;
var desc = "主队："+this.homeTeamName+'\r\n客队：'+this.visitTeamName;
var homeTeamTotalScore = this.homeTeamScore+this.homeTeamPKScore;
var visitTeamTotalScore = this.visitTeamScore+this.visitTeamPKScore;
wxShareConfig({
title: '最新赛果',
desc: this.homeTeamName+homeTeamTotalScore+"-"+visitTeamTotalScore+this.visitTeamName,
link: fullPath,
imgUrl: shareImg,
type: 'link',
dataUrl: ''
}, () => {

}, () => {

});
} else {
document.title = "比赛预告";
var realPath = window.location.href;
var fullPath = realPath.substring(0,realPath.indexOf('/match_info'))+'/match_info_share?matchId='+this.matchId;
var shareImg = window.location.origin + configInfo.routerBase + "static/logo.png";
var title = this.leagueName;
var desc = "主队："+this.homeTeamName+'\r\n客队：'+this.visitTeamName;

wxShareConfig({
title: title,
desc: desc,
link: realPath,
imgUrl: shareImg,
type: 'link',
dataUrl: ''
}, () => {
}, () => {
},fullPath);
}


}, (error) => {
console.log(error);
window.alert('比赛信息获取失败！');
})









this.eventHub.$on('resetView',()=>{
this.$nextTick(() => {
this.$refs.scroller.reset();
})
})

},
methods:{
first_handlerMatchScores(){
this.currentTab = 'matchScoresTab'
this.$refs.matchScoresTab.initTab()
},
first_handlerMatchMoments(){
this.currentTab = 'matchMomentsTab'
this.$refs.matchMomentsTab.initTab()
},
first_handlerMatchLive(){
this.currentTab = 'matchLiveTab'
this.$refs.matchLiveTab.initTab()
},
first_handlerMatchDynamicData(){
this.currentTab = 'matchDynamicDataTab'
this.$refs.matchDynamicDataTab.initTab()
},
handlerMatchScores(){
this.currentTab = 'matchScoresTab'

this.loadMore();
},
handlerMatchMoments(){
this.currentTab = 'matchMomentsTab'

this.loadMore();
},
handlerMatchDynamic(){
this.currentTab = 'matchDynamicTab'

this.loadMore();
},
handlerMatchLive(){
this.currentTab = 'matchLiveTab'

this.loadMore();
},
handlerMatchDynamicData(){
this.currentTab = 'matchDynamicDataTab'

},

handlerMatchScoresListener(){

this.$refs.scroller.reset();
},
handlerMatchMomentsListener(){

this.$refs.scroller.reset();
},
handlerMatchDynamicListener(){

this.$refs.scroller.reset();
},
handlerMatchLiveListener(){

this.$refs.scroller.reset();
},
loadMore(){





},
jump: function () {
window.open(this.liveUrl, '_blank');
}
}
}



// WEBPACK FOOTER //
// ./src/views/matchInfo.vue